import type { PayeeOrganizationDto } from "@fp/admin-api-client/types/payeeOrganizationDto.js";
import type { ReactNode } from "react";
import { Badge } from "@/components/base/badges/badges";

interface PayeeOrganizationRowProps {
  payeeOrganization: PayeeOrganizationDto;
  actions?: ReactNode;
}

export const PayeeOrganizationRow = ({
  payeeOrganization,
  actions,
}: PayeeOrganizationRowProps) => {
  return (
    <>
      <div className="flex items-center flex-1 min-w-0">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <p className="truncate text-sm font-semibold text-gray-700">
              {payeeOrganization.name}
            </p>
            <div className="flex items-center gap-2 shrink-0">
              <Badge size="sm" color="indigo">
                Organization
              </Badge>
              {!payeeOrganization.isActive && (
                <Badge size="sm" color="gray">
                  Inactive
                </Badge>
              )}
            </div>
          </div>
        </div>
      </div>
      {actions}
    </>
  );
};
